<template>
  <div class="dizme_tm_section" id="პორტფოლიო">
    <div class="dizme_tm_portfolio">
      <div class="container">
        <div class="dizme_tm_main_title" data-align="center">
          <span>პორტფოლიო</span>
          <h3>ჩემი საუკეთესო ნამუშევრები</h3>
          <p style="margin-bottom: 20px;">
            ჩემი ვიდეოები სავსეა სითბოთი, ემოციებითა და მხატვრული
            ხედვით, რაც თითოეულ კადრზე გამოიხატება. გაეცანით ჩემს
            საუკეთესო ნამუშევრებს და აღმოაჩინეთ, როგორ ვიღებ
            განსაკუთრებულ მომენტებს თქვენი ცხოვრების 
            მნიშვნელოვან მოვლენებზე.
          </p>
        </div>
        <div class="dizme_tm_portfolio_titles"></div>
        <div class="portfolio_list wow fadeInUp" data-wow-duration="2s">
          <ul class="gallery_zoom grid">
            <li class="youtube grid-item">
              <div class="inner">
                <div
                  class="entry dizme_tm_portfolio_animation_wrap"
                  data-title="V & I"
                  data-category="Youtube"
                >
                  <a
                    class="popup-youtube"
                    href="#"
                    @click.prevent="() => onClick('youtube', 'DO5wZEvc-Fk')"
                  >
                    <img src="/img/thumbs/42-56.jpg" alt="ქორწილის საუკეთესო კადრები – Valera Zhvania" width="300" height="200" />
                    <div class="main" data-img-url="/img/portfolio/1.jpg"></div>
                  </a>
                </div>
                <div class="mobile_title">
                  <h3>V & I</h3>
                  <span>Youtube</span>
                </div>
              </div>
            </li>
            <li class="youtube grid-item">
              <div class="inner">
                <div
                  class="entry dizme_tm_portfolio_animation_wrap"
                  data-title="T & T"
                  data-category="Youtube"
                >
                  <a
                    class="popup-youtube"
                    href="#"
                    @click.prevent="() => onClick('youtube', 'WeI7ySrjXBg')"
                  >
                    <img src="/img/thumbs/42-56.jpg" alt="ვიდეოგრაფი ქორწილისთვის – სრულყოფილი კადრები" width="300" height="200" />
                    <div class="main" data-img-url="/img/portfolio/2.jpg"></div>
                  </a>
                </div>
                <div class="mobile_title">
                  <h3>T & T</h3>
                  <span>Youtube</span>
                </div>
              </div>
            </li>
            <li class="youtube grid-item">
              <div class="inner">
                <div
                  class="entry dizme_tm_portfolio_animation_wrap"
                  data-title="T & M"
                  data-category="Youtube"
                >
                  <a
                    class="popup-youtube"
                    href="#"
                    @click.prevent="() => onClick('youtube', '6mRTgEZA3z4')"
                  >
                    <img src="/img/thumbs/42-56.jpg" alt="ემოციური ქორწილის ვიდეო – მომენტების აღბეჭდვა" width="300" height="200" />
                    <div class="main" data-img-url="/img/portfolio/3.jpg"></div>
                  </a>
                </div>
                <div class="mobile_title">
                  <h3>T & M</h3>
                  <span>Youtube</span>
                </div>
              </div>
            </li>
            <li class="youtube grid-item">
              <div class="inner">
                <div
                  class="entry dizme_tm_portfolio_animation_wrap"
                  data-title="T & T"
                  data-category="Youtube"
                >
                  <a
                    class="popup-youtube"
                    href="#"
                    @click.prevent="() => onClick('youtube', 'V53cxKuEL5s')"
                  >
                    <img src="/img/thumbs/42-56.jpg" alt="საქორწილო ფილმი – პროფესიონალური მონტაჟი" width="300" height="200" />
                    <div class="main" data-img-url="/img/portfolio/4.jpg"></div>
                  </a>
                </div>
                <div class="mobile_title">
                  <h3>T & T</h3>
                  <span>Youtube</span>
                </div>
              </div>
            </li>
            <li class="youtube grid-item">
              <div class="inner">
                <div
                  class="entry dizme_tm_portfolio_animation_wrap"
                  data-title="N & SH"
                  data-category="Youtube"
                >
                  <a
                    class="popup-youtube"
                    href="#"
                    @click.prevent="() => onClick('youtube', 'C-gDIxHUMbA')"
                  >
                    <img src="/img/thumbs/42-56.jpg" alt="საუკეთესო საქორწილო ვიდეო გადაღება" width="300" height="200" />
                    <div class="main" data-img-url="/img/portfolio/5.jpg"></div>
                  </a>
                </div>
                <div class="mobile_title">
                  <h3>N & SH</h3>
                  <span>Youtube</span>
                </div>
              </div>
            </li>
            <li class="youtube grid-item">
              <div class="inner">
                <div
                  class="entry dizme_tm_portfolio_animation_wrap"
                  data-title="I & B"
                  data-category="Youtube"
                >
                  <a
                    class="popup-youtube"
                    href="#"
                    @click.prevent="() => onClick('youtube', 'E5S3iAtJcAg')"
                  >
                    <img src="/img/thumbs/42-56.jpg" alt="ქორწილის ვიდეო მონტაჟი – უნიკალური სტილი" width="300" height="200" />
                    <div class="main" data-img-url="/img/portfolio/6.jpg"></div>
                  </a>
                </div>
                <div class="mobile_title">
                  <h3>I & B</h3>
                  <span>Youtube</span>
                </div>
              </div>
            </li>
            </ul>
        </div>
      </div>
      <div class="brush_1 wow zoomIn" data-wow-duration="2s">
        <img src="/img/brushes/portfolio/1.png" alt="პროფესიონალი ვიდეოგრაფი ქორწილისთვის" />
      </div>
      <div class="brush_2 wow fadeInRight" data-wow-duration="2s">
        <img src="/img/brushes/portfolio/2.png" alt="დრონით გადაღებული ქორწილის კადრები" />
      </div>
    </div>
  </div>
  <MagnificPopUpVue
    :modal="modal"
    :close="closeModal"
    :name="name"
    :src="src"
  />
  <div :class="`${active === 1 ? '' : 'hidden_content'}`">
    <ModalBox :close="close">
      <div class="popup_details">
        <div class="top_image">
          <img src="img/thumbs/4-2.jpg" alt="საქორწილო დრონით გადაღებული ვიდეო" />
          <div
            class="main"
            data-img-url="img/portfolio/6.jpg"
            style="background-image: url('img/portfolio/6.jpg')"
          ></div>
        </div>
        <div class="portfolio_main_title">
          <h3>Global Evolution</h3>
          <span><a href="#">Detail</a></span>
          <div></div>
        </div>
        <div class="main_details">
          <div class="textbox">
            <p>
              We live in a world where we need to move quickly and iterate on
              our ideas as flexibly as possible.
            </p>
            <p>
              Mockups are useful both for the creative phase of the project -
              for instance when you're trying to figure out your user flows or
              the proper visual hierarchy - and the production phase when they
              phase when they will represent the target product. Building
              mockups strikes the ideal balance ease of modification.
            </p>
          </div>
          <div class="detailbox">
            <ul>
              <li>
                <span class="first">Client</span>
                <span>Alvaro Morata</span>
              </li>
              <li>
                <span class="first">Category</span>
                <span><a href="#">Detail</a></span>
              </li>
              <li>
                <span class="first">Date</span>
                <span>March 07, 2021</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="additional_images">
          <ul>
            <li>
              <div class="list_inner">
                <div class="my_image">
                  <img src="img/thumbs/4-2.jpg" alt="დრონით გადაღებული საოცარი ხედები" />
                  <div
                    class="main"
                    data-img-url="img/portfolio/1.jpg"
                    style="background-image: url('img/portfolio/1.jpg')"
                  ></div>
                </div>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <div class="my_image">
                  <img src="img/thumbs/4-2.jpg" alt="პროფესიონალური დრონით გადაღება" />
                  <div
                    class="main"
                    data-img-url="img/portfolio/2.jpg"
                    style="background-image: url('img/portfolio/2.jpg')"
                  ></div>
                </div>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <div class="my_image">
                  <img src="img/thumbs/4-2.jpg" alt="უნიკალური დრონით გადაღება ქორწილისთვის" />
                  <div
                    class="main"
                    data-img-url="img/portfolio/3.jpg"
                    style="background-image: url('img/portfolio/3.jpg')"
                  ></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ModalBox>
  </div>
</template>

<script>
import MagnificPopUpVue from "./popup/MagnificPopUp.vue";
import ModalBox from "./popup/ModalBox.vue";
export default {
  name: "PortfolioComponent",
  data() {
    return {
      activeNav: "1", // props
      name: "",
      src: "",
      modal: false,
      // Content
      active: 0,
    };
  },
  methods: {
    onClick(name, src) {
      this.name = name;
      this.src = src;
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
      this.name = "";
      this.src = "";
    },
    close() {
      this.active = 0;
    },
  },
  components: { MagnificPopUpVue, ModalBox },
};
</script>
